import { sum } from 'lodash';

export const months = [
    'Leden',
    'Únor',
    'Březen',
    'Duben',
    'Květen',
    'Červen',
    'Červenec',
    'Srpem',
    'Září',
    'Říjen',
    'Listopad',
    'Prosinec'
];

export function month2Human(monthId) {
    return `${months[monthId % 12]} ${1970 + monthId / 12}`
}

export function currentMonth() {
    const date = new Date()
    return (date.getFullYear() - 1970) * 12 + date.getMonth();
}

export function computeDebt(family, amounts) {
    const s = sum(amounts);
    const dt = currentMonth() - family.firstMonth;
    return s - dt * family.monthlyPayment;
}